import Component from '../abstracts/Component';
import TrackingComponent from "./TrackingComponent";

export default class MiniWishlistComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-wishlist-dropdown',
      main: '.js-wishlist',
      item: '.wishlist .product-item',
      wishlistItem: '.wishlist-item',
      addedMsg: '.item-added',
      icon: '.action.wishlist',
      remove: '.js-remove-wish',
      msg: '.notification-message-wrapper'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      active: 'active',
      removing: 'removing'
    };
  }

  constructor() {
    super();

    this.timeout = null;
    this.timeout2 = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.item = $(this.SELECTORS.item);
    this.addedMsg = $(this.SELECTORS.addedMsg);
    this.icon = $(this.SELECTORS.icon);
    this.remove = $(this.SELECTORS.remove);
    this.msg = $(this.SELECTORS.msg);
    this.updated = false;
    this.lastRemoved = null;
    this.notified = false;
    this.trackingComponent = new TrackingComponent();
  }

  openWishlist() {
    let ms = 3000;
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1280) {
      ms = 2000;
    }
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    this.container.removeClass('notify');
    this.container.addClass(this.CLASSES.show);
    this.container.addClass('item-added');
    $('.backdrop-header').addClass('visible');
    const keyboard = document.querySelector('[data-whatinput="keyboard"]');
    const focusableContainer = document.querySelector(this.SELECTORS.container + ' .added-notify');
    const firstFocusable = this.$getFirstFocusable(focusableContainer);
    if (keyboard) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 200);
    } else {
      this.timeout = setTimeout(() => {
        this.container.removeClass(this.CLASSES.show);
        $('.backdrop-header').removeClass('visible');
        this.timeout2 = setTimeout(() => {
          this.container.removeClass('item-added');
        }, 300);
      }, ms);
    }
  }

  openWishlistReminder() {
    let ms = 3000;
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1280) {
      ms = 2000;
    }
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    this.container.removeClass('item-added');
    this.container.addClass(this.CLASSES.show);
    this.container.addClass('notify');
    $('.backdrop-header').addClass('visible');
    const keyboard = document.querySelector('[data-whatinput="keyboard"]');
    const focusableContainer = document.querySelector(this.SELECTORS.container + ' .notlogged-notify');
    const firstFocusable = this.$getFirstFocusable(focusableContainer);
    if (keyboard) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 200);
    } else {
      this.timeout = setTimeout(() => {
        this.container.removeClass(this.CLASSES.show);
        $('.backdrop-header').removeClass('visible');
        this.timeout2 = setTimeout(() => {
          this.container.removeClass('notify');
        }, 300);
      }, ms);
    }
  }

  updateWishlist(isNotification) {

    let ctx = this;
    let $elem = ctx.main;

    return $.ajax({
      url: $elem.data('href'),
      dataType: "html",
      success: function (resp) {
        let $resp = $(resp);
        ctx.main.attr('data-wishlist-count', $resp.attr('data-wishlist-count'));
        if (!isNotification) {
          ctx.checkNotificationWishlist();
        }
        let isEmpty = $resp.children().hasClass('empty-body');
        if (isEmpty) {
          ctx.icon.removeClass('icon-wishlist-on');
          ctx.icon.addClass('icon-wishlist-off');
        }
        ctx.log('Miniwishlist updated...');
        $elem.html(resp);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  removeProduct(el, isWishlistPage) {

    let ctx = this;
    let $elem = $(el);
    let code = $elem.attr('data-code');

    // TODO for undo button
    // ctx.lastRemoved = $elem.parent();

    // per dropdown
    if (!isWishlistPage) {
      ctx.container.removeClass(ctx.CLASSES.show);
      $('.backdrop-header').removeClass('visible');
    }

    setTimeout(() => {

      if (!isWishlistPage) {
        ctx.container.removeClass('item-added');
      }

      $.ajax({
        url: isWishlistPage ? $elem.parents(ctx.SELECTORS.wishlistItem).find(ctx.SELECTORS.remove).attr('data-href') : $elem.attr('data-href'),
        dataType: "json",
        type: 'POST',
        success: function (resp) {

          let item = $(`${ctx.SELECTORS.wishlistItem}[data-code="${code}"]`);

          // setTimeout(function () {
          if (resp.count < 1) {
            ctx.msg.addClass(ctx.CLASSES.show);
          } else {
            ctx.msg.removeClass(ctx.CLASSES.show);
          }
          // }, 300);

          item.addClass(ctx.CLASSES.removing);
          setTimeout(function () {
            item.remove();
          }, 800);


          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, el)

        },
        error: function (xhr) {
          console.log(xhr);
        }
      });

    }, 300);

  }

  desktopBehaviour() {

    this.$on('mouseenter.wishlist', ({
      event
    }) => {
      clearTimeout(this.timeout);
      clearTimeout(this.timeout2);
      //update wishlist only on the first over
      this.firstUpdate(event, 'lg');

    }, `${this.SELECTORS.main}, ${this.SELECTORS.container}`);

    this.$on('mouseleave.wishlist', ({
      event
    }) => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });
    }, 'body', `${this.SELECTORS.container}, ${this.SELECTORS.container}`);

    $(`${this.SELECTORS.container} ${this.SELECTORS.icon}`).on("keydown", e => {
      const currentDropdown = e.currentTarget.parentElement;
      if (e.which == 13 || e.keyCode == 13) {
        e.preventDefault();
        if (currentDropdown.classList.contains(this.CLASSES.show)) {
          // faccio l'emit del close
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
            source: currentDropdown,
            res: 'lg'
          });
        } else {
          // faccio l'emit dell'open
          clearTimeout(this.timeout);
          clearTimeout(this.timeout2);
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.closeAll);
          this.firstUpdate(currentDropdown, 'lg');
        }
      }
    });

  }

  firstUpdate(event, br) {
    if (!this.updated) {
      this.updated = true;
      let ct;

      if (event.target) {
        ct = event.currentTarget;
      } else {
        ct = event;
      }

      this.updateWishlist().then(res => {
        if ($(`${this.SELECTORS.container}:not(.mobile)`).is(":hover") || this.icon.is(":focus")) {
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
            source: ct,
            res: br
          });
        }
      });

    } else {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.target ? event.currentTarget : event,
        res: br
      });
    }
  }

  checkNotificationWishlist() {
    // se siamo all'interno di queste pagine la wishlist notification partirà
    const pagesEnabled = ["t-homepage", "t-category-folded", "t-category", "t-sales", "t-editorial-listing", "t-clp", "t-product"];
    for (let i = 0; i < pagesEnabled.length; i++) {
      if ($('body').hasClass(pagesEnabled[i])) break;
      if (pagesEnabled.length - 1 == i) return;
    }

    let checkNotification = $(`${this.SELECTORS.main}[data-logged="false"]`);

    if (checkNotification.length) {
      let wishlistCount = parseInt(checkNotification.attr('data-wishlist-count'));
      let wishlistNotificationDate = sessionStorage.getItem("wishlistNotification");
      let wishlistNotificationConfirm = sessionStorage.getItem("wishlistNotificationConfirm");

      if (wishlistCount >= 3) {
        // fires after 15s
        setTimeout(() => {

          if (wishlistNotificationDate == null) {
            this.log('wishlist reminder');
            if (!this.updated) {
              this.updated = true;

              this.updateWishlist(true).then(res => {
                this.openWishlistReminder();
              });

            } else {
              this.openWishlistReminder();
            }
          }

          let timeToShow = 0;
          if (wishlistNotificationDate == null) {
            let newDate = new Date();
            sessionStorage.setItem("wishlistNotification", newDate);
            // default time to show (60s x 5m - 15s = 285000ms)
            timeToShow = 285000;
          } else {
            if(!this.notified){
              let actualDate = new Date();
              let notificationDate = new Date(wishlistNotificationDate);
              var difference = actualDate - notificationDate;
              if (difference < 285000) {
                timeToShow = 285000 - difference;
              }
            }
          }

          if (timeToShow > 0) {
            this.notified = true;
            setTimeout(() => {
              if (wishlistNotificationConfirm == null) {
                this.log('last wishlist reminder');
                if (!this.updated) {
                  this.updated = true;

                  this.updateWishlist(true).then(res => {
                    this.openWishlistReminder();
                  });

                } else {
                  this.openWishlistReminder();
                }
                sessionStorage.setItem("wishlistNotificationConfirm", "true");
              }
            }, timeToShow);
          }

        }, 15000);
      }

    }
  }

  bindEvents() {

    let ctx = this;

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, (e) => {

      let $elem = $(e.payload);
      let url = $elem.attr('data-href');
      this.originalFocus = e.payload;

      this.trackingComponent.trackAction('wishlistAdd', $elem.data(), $elem);

      $.ajax({
        url: url,
        data: {
          code: $elem.attr('data-code')
        },
        dataType: "html",
        success: function (resp) {
          $elem.attr('data-source', '');
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, $elem);
          if (resp > 0) {
            ctx.icon.removeClass('icon-wishlist-off');
            ctx.icon.addClass('icon-wishlist-on');
          }
        },
        error: function (xhr) {
          ctx.log('error in add to wishlist');
        }
      });

    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, (e) => {
      let source = $(e.payload).attr('data-source');
      if (source != "size-check") {
        this.updateWishlist().then(res => {
          this.updated = true;
          this.openWishlist();
          // TODO 'random' notification reminder
        });
      }
    });

    $('body').on('click.wishlist', ctx.SELECTORS.remove, function () {
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this)
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, (e) => {
      this.removeProduct(e.payload);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwishlistpage, (e) => {
      this.removeProduct(e.payload, true);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      let source = $(e.payload).attr('data-source');
      if (source != "size-check") {
        this.updateWishlist();
      }
    });

    this.checkNotificationWishlist();

    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      } else {
        this.$off('mouseenter.wishlist', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);
        this.$off('mouseleave.wishlist', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);
      }
    });

  }

  render() {
    this.bindEvents();
  }
}
